var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestionarReclamos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 11.6667V16.3333M14 11.6667V14M18.6667 11.6667V18.6667M4.66671 23.3333H23.3334C23.9522 23.3333 24.5457 23.0875 24.9833 22.6499C25.4209 22.2123 25.6667 21.6188 25.6667 21V9.33333C25.6667 8.7145 25.4209 8.121 24.9833 7.68342C24.5457 7.24583 23.9522 7 23.3334 7H14.0817C13.6974 6.99801 13.3195 6.90112 12.9817 6.71795C12.6438 6.53477 12.3564 6.27098 12.145 5.95L11.1884 4.55C10.977 4.22902 10.6896 3.96523 10.3518 3.78205C10.0139 3.59888 9.63602 3.50199 9.25171 3.5H4.66671C4.04787 3.5 3.45438 3.74583 3.01679 4.18342C2.57921 4.621 2.33337 5.21449 2.33337 5.83333V21C2.33337 22.2833 3.38337 23.3333 4.66671 23.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestionarReclamos);
export default __webpack_public_path__ + "static/media/gestionar-reclamos.fe508da12b06e67fbb2cfe35cec7c169.svg";
export { ForwardRef as ReactComponent };